import { themeColor } from "./_helpers";

export const blurTokens = {
  alpha500: themeColor({
    base: "{colors.whiteAlpha.500}",
    _themeBlack: "{colors.blackAlpha.500}",
    _themeWhite: "{colors.whiteAlpha.500}",
  }),
  alpha900: themeColor({
    base: "{colors.whiteAlpha.900}",
    _themeBlack: "{colors.blackAlpha.900}",
    _themeWhite: "{colors.whiteAlpha.900}",
  }),
};
